(() => {
  'use strict';
  const callbacks = window.SwymCallbacks = window.SwymCallbacks || [];
  callbacks.push(swat => {
    // The native picker owns complete membership reads and queues its removals.
    if (swat.dacNative) return;
    if (window.__dacWishlistUndo) return;
    window.__dacWishlistUndo = true;
    let context, busy = false;
    const replay = new WeakSet();
    const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
    const fetchLists = () => new Promise((resolve, reject) => { const timer = setTimeout(() => reject(new Error('Wishlist unavailable')), 15000); swat.fetchLists({ callbackFn: lists => { clearTimeout(timer); resolve(lists); }, errorFn: err => { clearTimeout(timer); reject(err); } }); });
    const member = (list, item) => (list.listcontents || []).find(p => String(p.epi) === String(item.epi) && String(p.empi) === String(item.empi));
    const queue = (lists, item) => window.DACListUndo.scheduleBatch(lists.map(list => ({ kind: 'wishlist', lid: String(list.lid),
      item: { epi: item.epi, empi: item.empi, du: item.du }, title: item.dt || member(list, item)?.dt || "Sett", listName: list.lname })));
    function product(button) {
      const data = button.dataset;
      const variant = data.variantId || window.SwymProductInfo?.currentVariant || window.SwymPageData?.epi;
      const page = data.productId ? {} : (window.SwymProductVariants?.[variant] || window.SwymPageData || {});
      const item = { ...page, epi: variant, empi: data.productId || page.empi, du: data.productUrl || page.du };
      if (!/^\d+$/.test(String(item.epi)) || !/^\d+$/.test(String(item.empi)) || !item.du) return null;
      return item;
    }
    function error(where) {
      let node = where.querySelector('.dac-wishlist-undo-error');
      if (!node) { node = document.createElement('p'); node.className = 'dac-wishlist-undo-error'; node.setAttribute('role', 'alert'); where.append(node); }
      node.textContent = "Vi kunne ikke oppdatere ønskelisten din. Prøv igjen.";
    }
    function repaint(item, lists) {
      document.querySelectorAll('.swym-add-to-wishlist, .swym-add-to-wishlist-view-product').forEach(button => {
        const current = product(button);
        if (!current || String(current.epi) !== String(item.epi)) return;
        const selected = lists.some(list => member(list, item) && !window.DACListUndo.has('wishlist', list.lid, item.epi));
        button.classList.toggle('swym-added', selected);
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-label', selected ? "Fjern fra ønskelisten" : "Legg til i ønskelisten");
      });
    }
    window.addEventListener('click', async event => {
      const button = event.target.closest?.('.swym-add-to-wishlist, .swym-add-to-wishlist-view-product');
      if (!button || replay.has(button) || !window.DACListUndo) return;
      const item = product(button);
      if (!item) return;
      const lists = fetchLists();
      lists.catch(() => {});
      context = { item, lists, button };
      const pending = window.DACListUndo.pending().filter(e => e.kind === 'wishlist' && String(e.item.epi) === String(item.epi));
      const selected = button.getAttribute('aria-pressed') === 'true' || button.classList.contains('swym-added');
      if (!selected && !pending.length) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy) return;
      busy = true; button.setAttribute('aria-busy', 'true');
      try {
        const snapshot = await lists;
        if (pending.length) pending.forEach(e => window.DACListUndo.cancel('wishlist', e.lid, item.epi));
        else {
          const memberships = snapshot.filter(list => member(list, item));
          if (memberships.length === 1) queue(memberships, item);
          else { replay.add(button); button.click(); replay.delete(button); }
        }
        repaint(item, snapshot);
      } catch (_) { error(button.parentElement); }
      finally { busy = false; button.removeAttribute('aria-busy'); }
    }, true);
    window.addEventListener('click', async event => {
      const button = event.target.closest?.('.swym-add-wishlist-modal .swym-add-to-list-btn');
      if (!button || replay.has(button) || !context || !window.DACListUndo) return;
      const captured = context, modal = button.closest('.swym-add-wishlist-modal');
      if (modal.dataset.dacProductId && (String(captured.item.empi) !== modal.dataset.dacProductId || String(captured.item.epi) !== modal.dataset.dacVariantId)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy) return;
      busy = true; button.disabled = true;
      try {
        const lists = await captured.lists;
        const selections = [...modal.querySelectorAll('.swym-wishlist-item')].map(node => {
          const name = clean(node.querySelector('.swym-wishlist-name')?.textContent);
          const matches = lists.filter(list => clean(list.lname) === name);
          if (matches.length !== 1) throw new Error('Ambiguous list');
          return { list: matches[0], selected: node.getAttribute('aria-checked') === 'true' };
        });
        const removed = selections.filter(row => !row.selected && member(row.list, captured.item)).map(row => row.list);
        if (!removed.length) {
          button.disabled = false; replay.add(button); button.click(); replay.delete(button); return;
        }
        const additions = selections.filter(row => row.selected && !member(row.list, captured.item)).map(row => row.list);
        const createdNames = [...modal.querySelectorAll('.swym-new-wishlist-item.swym-selected input')].map(input => clean(input.value));
        if (createdNames.some(name => !name) || modal.querySelector('.swym-input-has-error')) throw new Error('Invalid list');
        if (createdNames.length) {
          const created = await new Promise((yes, no) => swat.createLists(createdNames.map(lname => ({ lname })), yes, no));
          additions.push(...created);
        }
        for (const list of additions) await new Promise((yes, no) => swat.addToList(list.lid, captured.item, yes, no));
        queue(removed, captured.item);
        window.DACWishlistUI?.confirmSaved?.(modal);
        modal.querySelector('.swym-close-btn').click();
        repaint(captured.item, await fetchLists());
      } catch (_) { error(modal.querySelector('.swym-action-btns') || modal); }
      finally { busy = false; button.disabled = false; }
    }, true);
    document.addEventListener('dac:list-change', event => {
      const entry = event.detail?.entry;
      if (entry?.kind !== 'wishlist') return;
      if (!document.querySelector('.swym-add-to-wishlist, .swym-add-to-wishlist-view-product')) return;
      const lists = event.detail.outcome !== 'saved' && context ? context.lists : fetchLists();
      lists.then(snapshot => repaint(entry.item, snapshot)).catch(() => {});
    });
  });
})();
